import React, {useContext,useEffect,useState} from 'react'
import {Button, Grid, Box ,Switch,FormGroup,FormControlLabel,Select,makeStyles ,FormControl,RadioGroup,Radio,FormLabel} from "@material-ui/core";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import { Textarea, Typography } from "@material-tailwind/react";
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';

export const Acciones = ({status_actual_tramite,usuario,iniciarGrabar,eliminar,objestados,cabecera,iniciarReactivar,usuarioEsSedeHabilitado})=>{
  
    const useStyle = makeStyles({
        select: {
            background: 'white',
            color:'black'
        }
      });

    const classes = useStyle();

    if (cabecera.tipo=='afiliacion'){
        return <div> 
                    {status_actual_tramite=='Iniciado' 
                        && (usuario.perfil=="sede" && usuario?.rol_contabilidad && usuario?.rol_contabilidad > 50) 
                        &&   <div className='mt-2 mb-10 grid grid-cols-1 md:grid-cols-2 gap-2'>

                        <Button 
                            title="Como primer paso debe ingresar el trámite a la tesorería para que se tome en cuenta para su procesamiento" 
                            startIcon={<ArrowRightAltIcon/>} 
                            onClick={()=>iniciarGrabar({status:objestados.tesoreria.nombre})}>
                                        Ingresar a tesorería
                        </Button>
                        <Button 
                            title='Puede eliminar un trámite cuando el solicitante lo requiera a la secretaría siempre que se encuentre en estado Iniciado' 
                            startIcon={<DeleteIcon/>} 
                            onClick={()=>eliminar({id:cabecera._id,usuario:usuario.nombre,id_usuario:usuario.id_usuario,observaciones:'Eliminado desde módulo administrativo'})}>
                                            Eliminar
                        </Button>
                        
                    </div>}
                    {status_actual_tramite=='Rechazado' && usuarioEsSedeHabilitado && <Reactivar iniciarReactivar={iniciarReactivar}/>}
                 </div>
    }
    return <div> 
                {status_actual_tramite=='Iniciado' && (usuario.perfil=="region" || (usuario.perfil=="sede" && usuario.rol_sede>95)) && 
                <div className='mt-2 mb-10 grid grid-cols-1 md:grid-cols-2 gap-2'>
                    {cabecera.tipo!="nuevo_patrocinado" && 
                    <Button 
                        title="Como primer paso debe ingresar el trámite a la secretaría para que se tome en cuenta para su procesamiento" 
                        startIcon={<ArrowRightAltIcon/>} 
                        variant="contained"  
                        onClick={()=>iniciarGrabar({status:objestados.procRegion.nombre})}>
                                    Ingresar a secretaría regional 
                    </Button>}
                    <Button 
                        title='Puede eliminar un trámite cuando el solicitante lo requiera a la secretaría siempre que se encuentre en estado Iniciado' 
                        startIcon={<DeleteIcon/>} 
                        variant="contained"
                        onClick={()=>eliminar({id:cabecera._id,usuario:usuario.nombre,id_usuario:usuario.id_usuario,observaciones:'Eliminado desde módulo administrativo'})}>
                                        Eliminar
                    </Button>
                </div>}
                {status_actual_tramite=='Rechazado' && usuarioEsSedeHabilitado && <Reactivar iniciarReactivar={iniciarReactivar}/>}
           </div>
            
}

// const Reactivar = ({iniciarReactivar})=>{
//      return  <div className='mt-2 mb-10 grid grid-cols-1 md:grid-cols-2 gap-2'>
//                 <Button 
//                     title={`Al reactivar un trámite rechazado se pasará al estado "En proceso regional" y se resetearán los campos de actas`} 
//                     startIcon={<ArrowRightAltIcon/>}
//                     onClick={()=>iniciarReactivar('algo')}>
//                                 Reactivar
//                 </Button>
//             </div>
// }

const Reactivar = ({ iniciarReactivar }) => {
    const [mostrarInput, setMostrarInput] = useState(false);
    const [observacion, setObservacion] = useState("");

    const handleCancelar = () => {
        setMostrarInput(false);
        setObservacion("");
    };

    const handleContinuar = () => {
        if (!observacion.trim()) return;
        iniciarReactivar(observacion);
        setMostrarInput(false)
    };

    return (
        <div className='mt-2 mb-10 w-full'>
            {!mostrarInput ? (
                /* Botón Inicial de MUI */
                <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<SettingsBackupRestoreIcon />}
                        sx={{ 
                            textTransform: 'none', 
                            fontWeight: 'bold',
                            padding: '8px 16px' 
                        }}
                        title='Al reactivar un trámite rechazado se pasará al estado "En proceso regional"' 
                        onClick={() => setMostrarInput(true)}
                    >
                        Reactivar
                    </Button>
                </div>
            ) : (
                /* Formulario de Observación (Material Tailwind) */
                <div className='bg-blue-gray-50/50 p-4 rounded-lg border border-blue-gray-100 animate-fade-in'>
                    <Typography variant="small" color="blue-gray" className="mb-2 font-bold flex items-center gap-2 text-[13px]">
                        <ArrowRightAltIcon className="w-4 h-4 rotate-90 text-blue-500" /> 
                        INGRESE MOTIVO DE REACTIVACIÓN (OBLIGATORIO)
                    </Typography>
                    
                    <Textarea 
                        variant="outlined"
                        label="Observación"
                        value={observacion}
                        onChange={(e) => setObservacion(e.target.value)}
                        rows={3}
                        className="bg-white"
                        autoFocus
                    />

                    <div className='flex gap-2 mt-3'>
                        <Button 
                            size="sm" 
                            color="green" 
                            variant="gradient"
                            onClick={handleContinuar}
                            disabled={!observacion.trim()}
                        >
                            Continuar
                        </Button>
                        <Button 
                            size="sm" 
                            color="red" 
                            variant="text" 
                            onClick={handleCancelar}
                        >
                            Cancelar
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};
export default Reactivar;